export default __webpack_public_path__ + "static/media/bg--web.4d178389.png";